import importerSelectors from '../../../modules/shared/importer/importerSelectors'

const artistImporterSelectors = importerSelectors(
  'artist.importer',
)

export default artistImporterSelectors
